export const taxIntegrationdashboard = {
    padding: '8px',
    boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)',
    position: 'relative'
};

export const taxSubheader = {
    backgroundColor: "white",
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    paddingTop: '16px',
    paddingBottom: '4px',
    color:'#007ac3',
    width:'100%'
};

export const taxSubheaderItem = {
    borderBottom: '1px solid',
    paddingBottom: '6px',
    paddingLeft:'30px',
    paddingRight:'30px'
};

export const taxSubheaderItemCursor = {
    cursor: 'pointer'
};

export const taxToBeLinkedPage = {
    backgroundColor: "white",
    paddingTop: '12px'
};
